import { Controller } from "@hotwired/stimulus"
import React from "react"
import { createRoot } from "react-dom/client"

import FreePlanQuotaNotification from "#Components/Navigation/FreePlanQuotaNotification"
import { ReactQueryProvider } from "#Utils/react-query-client"

export default class extends Controller {
  static values = {
    organizationSlug: String,
  }

  initialize() {
    this.root = createRoot(this.element)
    this.renderComponent()
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }

  renderComponent() {
    this.root.render(
      React.createElement(
        ReactQueryProvider,
        null,
        React.createElement(FreePlanQuotaNotification, {
          organizationSlug: this.organizationSlugValue,
          enabled: true,
        }),
      ),
    )
  }

  organizationSlugValueChanged() {
    if (this.root) {
      this.renderComponent()
    }
  }
}
